<script>
import { Doughnut, mixins } from "vue-chartjs";
 /* eslint-disable no-unused-vars */

const { reactiveProp } = mixins;

export default {
  extends: Doughnut,
  name: "DoughnutChart",
  mixins: [reactiveProp],
  props: {
    organisationName: {
      type: String,
    },
    chartData: {
      type: Object,
      required: false
    },
  },
  data() {
    return {
      options: {
        responsive: true,
        onClick: this.handle,
        maintainAspectRatio: true,
        animation: {
          animateRotate: true
        },
        borderWidth: 1,
        legend: {
          display: false
        },
        plugins: {
          datalabels: {
            color: 'white',
            textAlign: 'center',
            font: {
              weight: "bold",
              size: 16
            },
            formatter: (value, ctx) => {
                let sum = 0;
                let dataArr = ctx.chart.data.datasets[0].data;
                dataArr.map(data => {
                    sum += data;
                });
                let percentage = (value*100 / sum).toFixed(0)+"%";
                return (value*100 / sum).toFixed(0) > 0 ? percentage : '';
            },
          }
        }
      },
    };
  },
  methods: {
    update() {
      this.$data._chart.update();
    },
    handle() { //point, event
      this.$emit('on-receive')
    },
  },
  mounted() {
    this.renderChart(this.chartData, this.options);
  }
};
</script>
